module.exports = __webpack_public_path__ + "static/H-Benchmark-8f3d10eba1d4727591483859ce70d498.png";